// extracted by mini-css-extract-plugin
export default {"appBar":"Z3e+","sticky":"sdt-","reference":"A5Kg"};